import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconsModule } from '../../core-ui/Icons/Icons.module';
import { TooltipModule } from '../Tooltip/Tooltip.module';
import { DirectivesModule } from './../Directives/Directives.module';
import { ArrayToSingleModelHigherOrderComponent } from './ArrayToSingleModelHigherOrder.component';
import { ColorPalettePickerModule } from './ColorPalettePicker/ColorPalettePicker.module';
// TODO need to do some extensive testnig to see where this might break things
// import { AbstractIconComponent } from '../../generic-components/Icons/AbstractIcon.component';
import { OkAlertComponent } from './OkAlert.component';
import { OkCheckboxComponent } from './OkCheckbox.component';
import { OkExpansionPanelComponent } from './OkExpansionPanel.component';
import { OkMultiLevelExpansionPanelComponent } from './OkMultiLevelExpansionPanel.component';
import { OkPillComponent } from './OkPill.component';
import { OkPillboxComponent } from './OkPillbox.component';
import { OkPillboxWithTypeaheadComponent } from './OkPillboxWithTypeahead.component';
import { OkRadioComponent } from './OkRadio.component';
import { OkSelectComponent } from './OkSelect.component';
import { OkTypeAheadComponent } from './OkTypeahead.component';

const OkapiInternalComponents: any[] = [];

export const OkapiExports = [
    OkPillboxComponent,
    OkCheckboxComponent,
    OkTypeAheadComponent,
    OkPillComponent,
    OkPillboxWithTypeaheadComponent,
    OkExpansionPanelComponent,
    OkMultiLevelExpansionPanelComponent,
    OkRadioComponent,
    ArrayToSingleModelHigherOrderComponent,
    OkSelectComponent,
    OkAlertComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IconsModule,
        ColorPalettePickerModule,
        TooltipModule,
        DirectivesModule
    ],
    declarations: [...OkapiInternalComponents, ...OkapiExports],
    exports: [...OkapiExports],
    providers: []
})
export class OkapiModule {}
